import { SingleValueInput } from './formelements/single-value-input';
import { MultiValueInput } from './formelements/multi-value-input';
import { FileUpload } from './formelements/file-upload';
import { HiddenSfFields } from './formelements/hidden-sf-fields';
import { FormValidation } from './form-validation';
import { ElementHelpers } from '../helpers/element-helpers';

/**
 * Standard form class, with default functionality
 */

export class FormHandler {

	/**
	 * @param {HTMLElement} elem - form element
	 * @constructor
	 */
	constructor(elem) {
		this.elem = elem;
		this.singleValueInputs = [];
		this.multiValueInputs = [];
		this.fileUploadInputs = [];
		this.validation = null;
		this.validationUrl = elem.getAttribute('data-validation-url');

		if (this.validationUrl && this.validationUrl.length > 3) {
			// only continue when validation is set on the form
			this.initFormfields();
			this.initFormValidation();
			if (window.hiddenSfFields) {
				this.initHiddenSfFields(elem);
			}
			this.addEventHandlers();
		} else {
			this.initFormfields();
		}
	}

	static getSelector() {
		return 'form';
	}

	initFormfields() {
		this.singleValueInputs = ElementHelpers.getElementsAsArray(SingleValueInput.getSelector(), this.elem)
			.map(elem => new SingleValueInput(elem, this));
		this.multiValueInputs = ElementHelpers.getElementsAsArray(MultiValueInput.getSelector(), this.elem)
			.map(elem => new MultiValueInput(elem, this));
		this.fileUploadInputs = ElementHelpers.getElementsAsArray(FileUpload.getSelector(), this.elem)
			.map(elem => new FileUpload(elem, this));
	}

	initFormValidation() {
		this.validation = new FormValidation(this);
	}

	initHiddenSfFields(elem) {
		new HiddenSfFields(elem);
	}

	addEventHandlers() {
		this.elem.addEventListener('submit', (event) => {
			if (!this.validation.validated || this.validation.errors.length) {
				event.preventDefault();
				this.validation.validateForm();
			} else {
				this.elem.submit();
			}
		});
	}

}

